module.exports = __webpack_public_path__ + "static/media/favicon.9d99f875.png";